import client, { getResponseData } from './client';

export const getChatList = (data) => {
	return client({
		url: '/chat',
		method: 'get',
		params: data,
	}).then((res) => getResponseData(res));
};

export const getConversationData = (sessionId) => {
	return client({
		url: `/chat/${sessionId}`,
		method: 'get',
	}).then((res) => getResponseData(res));
};

export const reviewChat = (msgId, data) => {
	return client({
		url: `/chat/${msgId}`,
		method: 'patch',
		data,
	});
};
